import React from 'react';
import { Chip } from '@mui/material';
import { CONFIG_STATE_LABELS } from '../../utils/configVocabulary';

export interface PolicyStatusBadgeProps {
  label: string;
  kind?: 'status' | 'deployment' | 'scope' | 'pack';
  size?: 'small' | 'medium';
}

const toneFor = (
  kind: PolicyStatusBadgeProps['kind'],
  rawLabel: string,
): { color: 'default' | 'primary' | 'success' | 'warning' | 'error' | 'info'; variant: 'filled' | 'outlined' } => {
  const label = String(rawLabel || '').trim().toLowerCase();

  if (kind === 'deployment') {
    if (label.includes(CONFIG_STATE_LABELS.deployed.toLowerCase())) return { color: 'success', variant: 'outlined' };
    if (label.includes('deploying')) return { color: 'warning', variant: 'filled' };
    if (label.includes(CONFIG_STATE_LABELS.needsAction.toLowerCase()) || label.includes(CONFIG_STATE_LABELS.draft.toLowerCase())) {
      return { color: 'info', variant: 'outlined' };
    }
    if (label.includes('failed') || label.includes('timeout')) return { color: 'error', variant: 'filled' };
    if (label.includes('unknown')) return { color: 'default', variant: 'outlined' };
  }

  if (kind === 'scope') {
    if (label.includes('needs zone') || label.includes('needs line') || label.includes('missing') || label.includes('no zones')) {
      return { color: 'warning', variant: 'outlined' };
    }
    if (label.includes('whole') || label.includes('all cameras')) {
      return { color: 'info', variant: 'outlined' };
    }
  }

  if (label === CONFIG_STATE_LABELS.live.toLowerCase()) return { color: 'success', variant: 'filled' };
  if (label === CONFIG_STATE_LABELS.draft.toLowerCase()) return { color: 'default', variant: 'outlined' };
  if (label === CONFIG_STATE_LABELS.blocked.toLowerCase()) return { color: 'error', variant: 'filled' };
  if (label === CONFIG_STATE_LABELS.needsAction.toLowerCase()) return { color: 'warning', variant: 'filled' };
  if (label === 'invalid') return { color: 'error', variant: 'filled' };
  if (label === 'needs attention') return { color: 'warning', variant: 'filled' };
  if (label === 'needs zone') return { color: 'warning', variant: 'filled' };

  return { color: 'default', variant: 'outlined' };
};

const PolicyStatusBadge: React.FC<PolicyStatusBadgeProps> = ({
  label,
  kind = 'status',
  size = 'small',
}) => {
  const tone = toneFor(kind, label);
  return (
    <Chip
      label={label}
      size={size}
      color={tone.color}
      variant={tone.variant}
      sx={{ fontWeight: 600 }}
    />
  );
};

export default PolicyStatusBadge;
